import { useReducer, useEffect } from 'react';
import { QUERY_STATE } from '../constants.js';
const initialFetchState = {
    queryState: QUERY_STATE.EMPTY,
    data: null,
    error: null,
    response: null,
};
const useFetchReducer = (state, action) => {
    switch (action.type) {
        case 'START': {
            return {
                ...state,
                queryState: QUERY_STATE.WAITING,
                data: null,
            };
        }
        case 'SUCCESS': {
            return {
                ...state,
                ...action.payload,
                queryState: QUERY_STATE.SUCCESS,
            };
        }
        case 'FAIL': {
            return {
                ...state,
                ...action.payload,
                queryState: QUERY_STATE.FAIL,
            };
        }
        case 'ABORT': {
            return {
                ...state,
                ...action.payload,
                queryState: QUERY_STATE.EMPTY,
            };
        }
        default: {
            return state;
        }
    }
};
export function useFetch(url, method = 'GET', body, headers) {
    const [fetchState, dispatchFetchAction] = useReducer(useFetchReducer, initialFetchState);
    useEffect(() => {
        // not work in IE
        const controller = new AbortController();
        const signal = controller.signal;
        const doIt = async () => {
            if (!url) {
                dispatchFetchAction({
                    type: 'ABORT',
                    payload: { error: null, response: null, data: null },
                });
                return;
            }
            dispatchFetchAction({ type: 'START' });
            let response = null;
            try {
                response = await fetch(url, { method, body, signal, headers });
                if (response.ok) {
                    const data = await response.json();
                    dispatchFetchAction({ type: 'SUCCESS', payload: { data, response } });
                }
                else {
                    dispatchFetchAction({
                        type: 'FAIL',
                        payload: {
                            error: new Error(`Cannot get data: ${response.statusText}`),
                            response,
                        },
                    });
                }
            }
            catch (error) {
                const name = error instanceof Error ? error.name : undefined;
                dispatchFetchAction({
                    type: name === 'AbortError' ? 'ABORT' : 'FAIL',
                    payload: {
                        error,
                        response,
                    },
                });
            }
        };
        doIt();
        return () => {
            controller.abort();
        };
    }, [dispatchFetchAction, url, method, body]);
    return fetchState;
}
//# sourceMappingURL=useFetch.js.map